const productsGalpao = [
  {
    id: 52,
    pinPos: [46.96062787961679, 625.3622158546234, -652.0732128646289],
    scale: 1.2,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -408.28869314910855,
        y: 399.87678237781387,
        z: -425.9401040649623,
      },
      target: {
        x: -407.5561289660199,
        y: 400.30056547549276,
        z: -426.4727930959902,
      },
      posMobile: {
        x: -408.28869314910855,
        y: 399.87678237781387,
        z: -425.9401040649623,
      },
      targetMobile: {
        x: -407.5561289660199,
        y: 400.30056547549276,
        z: -426.4727930959902,
      },
    },
    cameraOut: {
      pos: {
        x: 74.08723021749638,
        y: 270.602080145901,
        z: 174.9931219404095,
      },
      target: {
        x: 73.99999721203935,
        y: 270.68016327360453,
        z: 173.9999988725438,
      },
    },
  },
  {
    id: 53,
    pinPos: [314.35764634208294, 348.42778852383515, -2658.7289860497935],
    scale: 2.2,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -544.2138714530015,
        y: 233.85651442561954,
        z: -1841.9794216996409,
      },
      target: {
        x: -543.600537141852,
        y: 233.98739159723218,
        z: -1842.7583261794825,
      },
      posMobile: {
        x: -544.2138714530015,
        y: 233.85651442561954,
        z: -1841.9794216996409,
      },
      targetMobile: {
        x: -543.600537141852,
        y: 233.98739159723218,
        z: -1842.7583261794825,
      },
    },
    cameraOut: {
      pos: {
        x: 74.08723021749638,
        y: 270.602080145901,
        z: 174.9931219404095,
      },
      target: {
        x: 73.99999721203935,
        y: 270.68016327360453,
        z: 173.9999988725438,
      },
    },
  },
  {
    id: 54,
    pinPos: [-380.56193436021385, 48.95866903318063, -450.18548992655315],
    scale: 1,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -459.86414722547744,
        y: 83.79687499652911,
        z: -40.882388141722096,
      },
      target: {
        x: -459.8170407811818,
        y: 83.69981395848328,
        z: -41.8765511755346,
      },
      posMobile: {
        x: -459.86414722547744,
        y: 83.79687499652911,
        z: -40.882388141722096,
      },
      targetMobile: {
        x: -459.8170407811818,
        y: 83.69981395848328,
        z: -41.8765511755346,
      },
    },
    cameraOut: {
      pos: {
        x: 74.08723021749638,
        y: 270.602080145901,
        z: 174.9931219404095,
      },
      target: {
        x: 73.99999721203935,
        y: 270.68016327360453,
        z: 173.9999988725438,
      },
    },
  },
];

export default productsGalpao;
